module.exports = __webpack_public_path__ + "img/buddy_antenna-06.772bcce1.svg";